/* eslint-disable indent, react/jsx-indent, no-trailing-spaces */
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';

const baseStyle = makeStyles(theme => ({
    text: {
        fontSize: '18px',
        color: theme.palette.facet.primaryGray,
    },
}));

const clientFlyoutStyle = makeStyles(() => ({
    text: {
        fontSize: '15px',
    },
}));

const BaseSignatureDates = ({ classes, clients, label }) => {
    if (!Array.isArray(clients) || !clients.length) {
        return null;
    }

    if (!clients.every(client => client.type() === 'client')) {
        return null;
    }

    const primaryClient = clients.find(client => client.attr('isPrimary') === 'true');
    const primaryClientSignDate = moment.utc(primaryClient.attr('signDate'));
    const spouseClient = clients.find(client => client.attr('isPrimary') === 'false');
    const spouseClientSignDate = spouseClient ? moment.utc(spouseClient.attr('signDate')) : null;

    return (
        <div className={classes.text}>
            {/* display the sign date for the primary client */}
            {primaryClient
            && primaryClient.attr('signDate')
            && primaryClientSignDate.isValid()
            && (
                <>
                    <span>{label(primaryClientSignDate.format('MMMM Do YYYY'))}</span>
                    <br />
                    <span>{`${primaryClient.attr('firstName')} ${primaryClient.attr('lastName')} (${primaryClient.id()})`}</span>
                    <br />
                </>
            )}
            {/* display the spouse name under the primary client name if they signed on the same date */}
            {spouseClient
            && spouseClient.attr('signDate')
            && spouseClientSignDate instanceof moment
            && spouseClientSignDate.isValid()
            && primaryClientSignDate.isValid()
            && primaryClientSignDate.isSame(spouseClientSignDate, 'day')
            && (
                <>
                    <span>{`${spouseClient.attr('firstName')} ${spouseClient.attr('lastName')} (${spouseClient.id()})`}</span>
                    <br />
                </>
            )}
            {/* display the spouse name with a separate date if they signed on different dates */}
            {spouseClient
            && spouseClient.attr('signDate')
            && spouseClientSignDate instanceof moment
            && spouseClientSignDate.isValid()
            && primaryClientSignDate.isValid()
            && !primaryClientSignDate.isSame(spouseClientSignDate, 'day')
            && (
                <>
                    <span>{label(spouseClientSignDate.format('MMMM Do YYYY'))}</span>
                    <br />
                    <span>{`${spouseClient.attr('firstName')} ${spouseClient.attr('lastName')} (${spouseClient.id()})`}</span>
                    <br />
                </>
            )}
        </div>
    );
};

BaseSignatureDates.propTypes = {
    classes: PropTypes.object.isRequired,
    clients: PropTypes.arrayOf(fr.Resource).isRequired,
    label: PropTypes.func,
};

BaseSignatureDates.defaultProps = {
    label: signDateStr => `Effective ${signDateStr}`,
};

const SignatureDates = ({ clients }) => {
    const classes = baseStyle();
    return <BaseSignatureDates classes={classes} clients={clients} />;
};

SignatureDates.propTypes = {
    clients: PropTypes.arrayOf(fr.Resource).isRequired,
};

SignatureDates.defaultProps = {};

export default SignatureDates;

// ClientFlyoutSignatureDates modifies the base component with different
// styling and a condensed label to make it fit into the narrow client settings
// flyout.
export const ClientFlyoutSignatureDates = ({ clients }) => {
    const classes = {
        ...baseStyle(),
        ...clientFlyoutStyle(),
    };
    const label = signDateStr => signDateStr;
    return <BaseSignatureDates classes={classes} clients={clients} label={label} />;
};

ClientFlyoutSignatureDates.propTypes = {
    clients: PropTypes.arrayOf(fr.Resource).isRequired,
};

ClientFlyoutSignatureDates.defaultProps = {};
